var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStreetView(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "011---Dropping-Man",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m57.52 56.66-3.52-9.93-2.15-6-1.76-4.92-1.57-4.42-.25-.7c-.1363202-.4183546-.5300769-.6984495-.97-.69h-10.07c-.5630056-.6411361-1.3767743-1.0060548-2.23-1h-12c-.8532257-.0060548-1.6669944.3588639-2.23 1h-10.06c-.4428242-.0261489-.84994889.2425534-1 .66l-.64 1.81-3.07 8.85-1.62 4.42-2 5.5-1.9 5.42c-.0514077.1797296-.0514077.3702704 0 .55.10064169.4691379.52030719.8006736 1 .79h55.1c.3258099-.0001386.6311253-.1589911.8182321-.4257178s.2325433-.6078823.1217679-.9142822z",
    fill: "#24ae5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m48.82 15.34-2.11-1.16c-3.91-2.11-10.8-5.7-17.88-8.74s-14.13-5.44-18.83-5.44c-.74 0-1.46 0-2.15.07-1.04176136.07835028-1.84771867.94529895-1.85 1.99v8.48c-.00136303.5556049.22845794 1.0867376.63438466 1.4661084.40592673.3793708.95137177.5727857 1.50561534.5338916 1.42997004-.1276432 2.8561658.282388 4 1.15 1.1509731.9157782 2.1209136 2.0383318 2.86 3.31.64 1.05 1.27 2.06 1.87 3s1.07 1.63 1.54 2.34c.35.52.69 1 1 1.43.6456903 1.0020896 1.9587017 1.3303424 3 .75.282718-.1559178.525678-.3749241.71-.64l10.88-4.26c.0652297-.5380301.0652297-1.0819699 0-1.62-.3303209-2.2700821-1.3821269-4.373694-3-6l15.7 7.44c.7161131.339683 1.5563751.2885078 2.2259721-.1355703.6695971-.4240782 1.0750221-1.1618381 1.0740279-1.9544297.0047213-.8356132-.4480505-1.6068602-1.18-2.01zm-19.82 1.66c-2.7209756-.0004535-5.1016163 1.8301771-5.8 4.46-.22-.46-.44-.95-.65-1.46-.7656904-1.550107-.9604357-3.3205191-.55-5 .67-2 3.48-1 4.81-.39 1.0902264.5013072 1.9909863 1.3389788 2.57 2.39-.1264607-.0102143-.2535393-.0102143-.38 0z",
    fill: "#fdd7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m56.58 58h-6.06l-17.47-7.54c.6295146-.472136 1-1.2131067 1-2v-5.74l5.35-2.3 2.6 1.14 4 1.73 8 3.44 3.54 9.93c.1120573.3097468.064391.6548103-.1274428.9225783s-.5032275.4238924-.8325572.4174217z",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m54 46.73-8-3.44-4-1.73-2.65-1.14-5.35 2.3v-3.72c0 1.1045695.8954305 2 2 2s2-.8954305 2-2v-3.12l10.49-4.52 1.57 4.42-4.83 2.08 6.59 2.84z",
    fill: "#f3d55b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m51.82 40.7-6.59-2.84 4.83-2.08z",
    fill: "#e57e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m38 35.88v-3.88c-.0016676-.7387322-.275843-1.4508762-.77-2h10.07c.4210301.0001791.7968498.2640526.94.66l.25.7z",
    fill: "#e57e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m20.77 30c-.494157.5491238-.7683324 1.2612678-.77 2v5.17l-10.88-4.7.64-1.81c.15005111-.4174466.5571758-.6861489 1-.66z",
    fill: "#f3d55b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m38.72 58h-37.3c-.47969281.0106736-.89935831-.3208621-1-.79l18.22-7.87 6.12 2.66.21.09z",
    fill: "#3b97d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m35 23c-.0173386 3.1296374-2.4373197 5.7202713-5.5585254 5.9505027-3.1212056.2302315-5.8951154-1.9772822-6.3714746-5.0705027.4218887-.5771472.5339873-1.3244714.3-2-.0211199-.0830546-.051301-.1635375-.09-.24 0-.05-.05-.1-.08-.16.6907653-2.6377603 3.0732927-4.4780574 5.8-4.48.1264607-.0102143.2535393-.0102143.38 0 3.1644499.2008119 5.6263652 2.8291912 5.62 6z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m28.83 5.44c4.59.69 13.11 2.12 16 3.56 4 2 2 5 2 5",
    fill: "#f9c795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m50.52 58h-11.8l-13.72-5.94-.24-.06-6.1-2.63-18.22 7.84c-.0514077-.1797296-.0514077-.3702704 0-.55l1.93-5.42 7.36-3.18-5.4-2.32 1.67-4.42 9.73 4.2 8.27-3.58v6.56c-.001185.6634943.2614303 1.3002463.73 1.77.2242651.2288961.4931543.4092901.79.53.7722631.3290637 1.658126.2485803 2.3584411-.2142717.7003152-.4628519 1.1215881-1.2462801 1.1215589-2.0857283-.0026715.6638566.2598627 1.3012947.729284 1.770716s1.1068594.7319555 1.770716.729284c.5633869.003572 1.1107906-.1871364 1.55-.54z",
    fill: "#f3d55b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m38 32v7c0 1.1045695-.8954305 2-2 2s-2-.8954305-2-2v9.5c0 .7868933-.3704854 1.527864-1 2-.4310012.327861-.9584824.5036881-1.5.5-.5409255 0-1.0672596-.1754447-1.5-.5-.0966339-.0685193-.1869891-.1454885-.27-.23-.4685697-.4697537-.731185-1.1065057-.73-1.77.0000292.8394482-.4212437 1.6228764-1.1215589 2.0857283-.7003151.462852-1.586178.5433354-2.3584411.2142717-.2968457-.1207099-.5657349-.3011039-.79-.53-.4685697-.4697537-.731185-1.1065057-.73-1.77v-9.5c0 1.1045695-.8954305 2-2 2s-2-.8954305-2-2v-7c0-1.6568542 1.3431458-3 3-3h12c1.6568542 0 3 1.3431458 3 3z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e57e25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m24 34v5c0 1.1045695-.8954305 2-2 2v-7c0-.5522847.4477153-1 1-1s1 .4477153 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m36 34v7c-1.1045695 0-2-.8954305-2-2v-5c0-.5522847.4477153-1 1-1s1 .4477153 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m30 40v10.5c-.0966339-.0685193-.1869891-.1454885-.27-.23-.4685697-.4697537-.731185-1.1065057-.73-1.77.0015817.7872658-.3692384 1.5289058-1 2v-10.5c0-.5522847.4477153-1 1-1s1 .4477153 1 1z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreetView);
export default __webpack_public_path__ + "static/media/street-view.25a1b3658773b8bf3f186d802079c875.svg";
export { ForwardRef as ReactComponent };